export const getBiomas = (state) => state.biomas.lista
export const getIsCarregandoListaBiomas = (state) => state.biomas.isCarregandoLista
export const getIsSavingBiomas = (state) => state.biomas.isSaving
export const getIsUpdatingBiomas = (state) => state.biomas.isUpdate
